module.exports = __webpack_public_path__ + "img/bird-growing.png";